import { render, staticRenderFns } from "./ShowUnableEnvelopeFurtherActionsModal.vue?vue&type=template&id=cbd23b44&lang=pug"
import script from "./ShowUnableEnvelopeFurtherActionsModal.vue?vue&type=script&lang=js"
export * from "./ShowUnableEnvelopeFurtherActionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports